import React from "react";
import classnames from "classnames";
import _ from "lodash";
import Card from "../Card";
import List from "../List";
import Button from "../Button";
import { TextInput } from "../Inputs";
import Loader from "../Loader";
import TrashIcon from "../icons/Trash.svg";
import CheckmarkIcon from "../icons/CheckmarkSmall.svg";
import styles from "./index.module.scss";

const CODE_ERRORS = {
  INVALID_CODE: "INVALID_CODE",
  EXPIRED_CODE: "EXPIRED_CODE",
  NOT_AVAILABLE_FOR_SERVING_OPTION: "NOT_AVAILABLE_FOR_SERVING_OPTION",
  NOT_AVAILABLE_FOR_LOCATION: "NOT_AVAILABLE_FOR_LOCATION",
  NOT_AVAILABLE_NOW: "NOT_AVAILABLE_NOW",
  REQUIRES_LOGIN: "REQUIRES_LOGIN",
};

const WrapWithCardIf = ({ wrap, children, appStyles, style }) =>
  wrap ? (
    <Card appStyles={appStyles} style={style}>
      {children}
    </Card>
  ) : (
    <div style={style}>{children}</div>
  );

export default class extends React.Component {
  addPromoCode = () => {
    if (this.textInput && this.textInput.inputElement.value) {
      this.props.addPromoCode(this.textInput.inputElement.value);
      this.textInput.clearInput();
    }
  };

  getErrorMessage = (promoCode) => {
    const { T, servingOptionTag, branch } = this.props;

    const { code, error } = promoCode;

    switch (error) {
      case CODE_ERRORS.INVALID_CODE:
        return `${T("The code")} ${code} ${T("is invalid")}`;
      case CODE_ERRORS.EXPIRED_CODE:
        return `${T("The code")} ${code} ${T("has expired")}`;
      case CODE_ERRORS.NOT_AVAILABLE_FOR_SERVING_OPTION:
        return `${T("The code")} ${code} ${T(
          `${T("is not available for")} ${_.toLower(servingOptionTag)}`,
        )}`;
      case CODE_ERRORS.NOT_AVAILABLE_FOR_LOCATION:
        return `${T("The code")} ${code} ${T(
          `${T("is not available for")} ${branch}`,
        )}`;
      case CODE_ERRORS.NOT_AVAILABLE_NOW:
        return `${T("The code")} ${code} ${T("is not available at this time")}`;
      case CODE_ERRORS.REQUIRES_LOGIN:
        return `${T("This code")} ${code} ${T("requires login")}`;
      default:
        return `${T("The code")} ${code} ${T("has an error")}`;
    }
  };

  render() {
    const {
      T,
      appStyles,
      promoCodes,
      removePromoCode,
      wrap,
      style,
      loading,
      tight,
    } = this.props;
    const errorMessage =
      _.get(promoCodes, "[0].error") && this.getErrorMessage(promoCodes[0]);

    return (
      <WrapWithCardIf appStyles={appStyles} wrap={wrap} style={style}>
        <Card.Title appStyles={appStyles} style={{ fontSize: "1.1rem" }}>
          {T("Have a Promo Code?")}
        </Card.Title>
        <List>
          {_.map(
            _.filter(_.reverse(_.clone(promoCodes)), { error: null }),
            (promoCode) => {
              return (
                <List.Item>
                  <div className={styles.PromoCodeInput}>
                    <div className={styles.PromotionCodeChosen}>
                      <CheckmarkIcon
                        className={styles.CheckMarkIcon}
                        style={{
                          color: appStyles.actionColor,
                          ...(appStyles.rtl
                            ? { marginLeft: 6 }
                            : { marginRight: 6 }),
                        }}
                      />
                      <span>{T("Promotion Code:")}</span>
                      <span
                        style={
                          appStyles.rtl ? { marginRight: 6 } : { marginLeft: 6 }
                        }
                      >{` ${promoCode.code}`}</span>
                    </div>
                    <TrashIcon
                      onClick={() => removePromoCode(promoCode.code)}
                      className={classnames(styles.Clickable, styles.TrashIcon)}
                      style={{ color: appStyles.actionColor }}
                    />
                  </div>
                </List.Item>
              );
            },
          )}
        </List>
        <Card.Content tightTop tight={tight}>
          {errorMessage && !loading && (
            <div
              role="alert"
              aria-atomic="true"
              aria-live="assertive"
              className={styles.Error}
            >
              {errorMessage}
            </div>
          )}
          {loading ? (
            <div
              style={{
                height: "100%",
                display: "flex",
                justifyContent: "center",
                marginTop: 16,
                width: 280,
              }}
            >
              <Loader appStyles={appStyles} />
            </div>
          ) : (
            <TextInput
              appStyles={appStyles}
              placeholder={T("Enter Promo Code")}
              noCheckmark
              refEl={(el) => (this.textInput = el)}
              style={tight && { fontSize: "0.8rem" }}
            >
              <Button
                appStyles={appStyles}
                onClick={this.addPromoCode}
                centered
                style={{
                  flexGrow: 0,
                  height: "100%",
                  borderRadius: appStyles.inputBorderRadius,
                }}
              >
                {T("Apply")}
              </Button>
            </TextInput>
          )}
        </Card.Content>
      </WrapWithCardIf>
    );
  }
}
